export const POS_LAST_ORDER_KEY = 'pos:last-order';

export const getPosLastOrderStorageKey = (tenantScope?: string | null, orderId?: string | null): string => {
  const scope = tenantScope && tenantScope.trim().length > 0 ? tenantScope.trim() : 'global';
  if (orderId && orderId.trim().length > 0) {
    return `${POS_LAST_ORDER_KEY}:${scope}:${orderId.trim()}`;
  }
  return `${POS_LAST_ORDER_KEY}:${scope}`;
};
